import { SET_FILTER_TEAMARR } from '../constants/index'
import LocalTeamFilter from '../../services/LocalTeamFilter';

const LocalTeamArr = LocalTeamFilter.getInstance()

export const setFilterTeamArrAction = (payload: (number | null)[]) => {
	LocalTeamArr.setTeamArrLocally(payload)
	return {
		type: SET_FILTER_TEAMARR,
		payload
	}
}

export const clearFilterTeamArrAction = () => {
	return {
		type: SET_FILTER_TEAMARR,
		payload: []
	}
}